import { render, staticRenderFns } from "./NotificationInvoiceCreate.vue?vue&type=template&id=572d7caa&scoped=true&"
import script from "./NotificationInvoiceCreate.vue?vue&type=script&lang=js&"
export * from "./NotificationInvoiceCreate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInvoiceCreate.vue?vue&type=style&index=0&id=572d7caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d7caa",
  null
  
)

export default component.exports